:root {
  color-scheme: dark;
  --bg: #0b0e14;
  --bg-panel: #12161f;
  --bg-input: #0d1017;
  --border: #232a3a;
  --border-strong: #35415a;
  --text: #e6e9f2;
  --text-dim: #8a93a6;
  --accent: #f7d046;
  --accent-strong: #ffe680;
  --cyan: #4fd6d0;
  --danger: #ff6b6b;
  --danger-bg: #3a1418;
  --success: #63e6a3;
  --success-bg: #10251a;
  --radius: 10px;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  background: var(--bg);
  color: var(--text);
}

body {
  background-image: radial-gradient(circle at 20% -10%, #1c2334 0%, transparent 45%),
    radial-gradient(circle at 90% 0%, #1a2a2f 0%, transparent 40%);
  min-height: 100vh;
}

#root {
  min-height: 100vh;
}

.page {
  max-width: 760px;
  margin: 0 auto;
  padding: 2.5rem 1.25rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.header h1 {
  margin: 0;
  font-size: clamp(1.75rem, 4vw, 2.4rem);
  letter-spacing: 0.02em;
  font-weight: 700;
}

.header .accent {
  color: var(--accent);
  text-shadow: 0 0 18px rgba(247, 208, 70, 0.35);
}

.subtitle {
  margin: 0.5rem 0 0;
  color: var(--text-dim);
  font-size: 1rem;
  line-height: 1.5;
}

.meta-line {
  margin: 0.6rem 0 0;
  font-size: 0.85rem;
  color: var(--cyan);
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace;
}

.panel {
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.btn {
  font: inherit;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid var(--border-strong);
  padding: 0.55rem 1rem;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, transform 80ms ease;
}

.btn:active {
  transform: translateY(1px);
}

.btn-ghost {
  background: transparent;
  color: var(--text);
}

.btn-ghost:hover {
  background: #1a2030;
  border-color: var(--cyan);
}

.btn-primary {
  background: var(--accent);
  color: #1a1500;
  border-color: var(--accent);
  font-size: 1rem;
  padding: 0.75rem 1.25rem;
  align-self: flex-start;
}

.btn-primary:hover:not(:disabled) {
  background: var(--accent-strong);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: progress;
}

.decklist-input {
  width: 100%;
  min-height: 320px;
  resize: vertical;
  background: var(--bg-input);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.9rem;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.9rem;
  line-height: 1.5;
}

.decklist-input:focus {
  outline: none;
  border-color: var(--cyan);
}

.decklist-input::placeholder {
  color: #4b5567;
}

.banner {
  border-radius: 8px;
  padding: 0.85rem 1rem;
  font-size: 0.92rem;
  line-height: 1.5;
  border: 1px solid transparent;
}

.banner-error {
  background: var(--danger-bg);
  border-color: #6b2530;
  color: var(--danger);
}

.banner-success {
  background: var(--success-bg);
  border-color: #1f4d34;
  color: var(--success);
}

.report {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.report-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.88rem;
  color: var(--text-dim);
}

.report-details details {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  background: var(--bg-input);
}

.report-details summary {
  cursor: pointer;
  font-weight: 600;
  color: var(--text);
}

.report-details ul {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
}

.report-details li {
  margin-bottom: 0.25rem;
}

.note {
  margin: 0;
  font-style: italic;
}

.footer {
  color: var(--text-dim);
  font-size: 0.82rem;
  text-align: center;
}

.footer code {
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 0.1rem 0.35rem;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace;
}

@media (max-width: 480px) {
  .page {
    padding: 1.5rem 1rem 3rem;
  }

  .panel {
    padding: 1.1rem;
  }
}
